import { STRINGS } from '@tm/shared'
import { createWorkspace } from '../blockly/config.js'
import { enableTapToAdd } from '../blockly/tapToAdd.js'
import { registerContextMenu } from '../blockly/contextMenu.js'
import { mountMobileToolbar } from '../blockly/mobileToolbar.js'
import { createProjectStore } from '../store/ProjectStore.js'
import { ensureGenerators } from '../codegen/index.js'
import { trackEvent } from '../analytics/plausible.js'
import { prewarmSandbox } from '../sandbox/host.js'
import { mountSpritePicker } from '../ui/SpritePicker.js'

let contextRegistered = false

function mountOrUpdateSpritePicker(el, store) {
  mountSpritePicker({
    parent: el,
    initialSprites: store.getInitialSprites(),
    onAdd: (sprite) => {
      const current = store.getInitialSprites()
      store.setInitialSprites([...current, sprite])
    },
  })
}

export function createBuildMode({ onWorkspaceReady, initialProject }) {
  const el = document.createElement('section')
  el.className = 'tm-build'
  el.setAttribute('role', 'tabpanel')
  el.setAttribute('aria-label', STRINGS.modeBuild)
  el.innerHTML = `
    <div id="tm-blockly-host" class="tm-blockly-host" aria-label="Area Blockly"></div>
    <div id="tm-blockly-toolbar-host" class="tm-blockly-toolbar-host"></div>
  `

  setTimeout(() => {
    const host = el.querySelector('#tm-blockly-host')
    const toolbarHost = el.querySelector('#tm-blockly-toolbar-host')
    if (!host) return

    if (!contextRegistered) {
      registerContextMenu()
      contextRegistered = true
    }

    ensureGenerators()
    const workspace = createWorkspace(host, { availableBlocks: initialProject?.availableBlocks })
    enableTapToAdd(workspace)
    mountMobileToolbar(toolbarHost, workspace)
    const store = createProjectStore(workspace)

    mountOrUpdateSpritePicker(el, store)
    store.subscribe((event) => {
      if (event?.type === 'project_loaded' || event?.type === 'initial_sprites_changed') {
        mountOrUpdateSpritePicker(el, store)
      }
    })

    if (initialProject) {
      store.loadFromProject(initialProject)
    }

    trackEvent('blockly_workspace_ready', {
      isMobile: window.matchMedia('(max-width: 768px)').matches,
    })

    el.__workspace = workspace
    el.__store = store
    onWorkspaceReady?.(workspace, store)
  }, 0)

  prewarmSandbox()

  return el
}
